const clients = [
    {
        env: 'homol',
        id: 11,
        language: 'pt',
        module: 'ZNAP_SECURITY',
        moduleName: 'portal',
        modulePath: '',
        port: 8080,
        system: 'VENTURUS',
        theme: 'venturus.js',
    },
]

const getClientConfigs = (clientId) => clients.find((client) => client.id === clientId)
const configs = getClientConfigs(11)

export default {
    ...configs,
    api_port: 8000,
    ENABLE_TRACING: false,
}
